import React, { useState } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Formik, Field } from "formik";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
  FieldInputDollar,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  clearFieldValues,
  ssnMasking,
} from "../../../utils";
import {
  getParticipantUpdatesReportInfo,
  getDownloadParticipantUpdatesReport,
  getCompaniesDropDown,
  getPlansDropDown,
  getSponsorOrganizationList,
  getMasterPlanList,
} from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import "react-input-range/lib/css/index.css";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ColumnMenu } from "./columnMenu";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { GridInnerFilters } from "../../../components/GridInnerFilters/GridInnerFilters";

class KendoGridDecimalCell extends React.Component {
  render() {
    const value = this.props.dataItem[this.props.field];
    return <td>$ {value}</td>;
  }
}

class ProductNameHeader extends React.Component {
  render() {
    return (
      <a className="k-link" onClick={this.props.onClick}>
        <span title={this.props.title}>{this.props.title}</span>
        {this.props.children}
      </a>
    );
  }
}

//const selectOne = { label: "Select One", value: null };
const allOption = { label: "All", value: null };

const emptycol = [
  {
    value: 0,
    label: "",
    className: "",
    columnName: "",
    field: "",
    width: 0,
    dataType: "",
    field1: "",
  },
];
const columns = [
  {
    value: 1,
    label: "Company Name",
    className: "column-companyName",
    columnName: "companyName",
    field: "companyName",
    width: 111,
    dataType: "alphaNumeric",
    field1: "companyName",
  },
  {
    value: 2,
    label: "Plan ID",
    className: "column-rkPlanNumber",
    columnName: "rkPlanNumber",
    field: "rkPlanNumber",
    width: 173,
    dataType: "alphaNumeric",
    field1: "rkPlanNumber",
  },
  {
    value: 3,
    label: "Employee ID",
    className: "column-employeeNo",
    columnName: "employeeNo",
    field: "employeeNo",
    width: 144,
    dataType: "alphaNumeric",
    field1: "employeeNo",
  },
  {
    value: 4,
    label: "SSN",
    className: "column-ssn",
    columnName: "ssn",
    field: "ssn",
    width: 144,
    dataType: "alphaNumeric",
    field1: "ssn",
  },
  {
    value: 5,
    label: "First Name",
    className: "column-firstName",
    columnName: "firstName",
    field: "firstName",
    width: 149,
    dataType: "alphaNumeric",
    field1: "firstName",
  },
  {
    value: 6,
    label: "Last Name",
    className: "column-lastName",
    columnName: "lastName",
    field: "lastName",
    width: 133,
    dataType: "alphaNumeric",
    field1: "lastName",
  },
  {
    value: 7,
    label: "Date of Birth",
    className: "column-dateOfBirth",
    columnName: "dateOfBirth",
    field: "dateOfBirth",
    width: 169,
    dataType: "date",
    field1: "dateOfBirthFrom",
    field2: "dateOfBirthTo",
  },
  {
    value: 8,
    label: "Updated Address Line 1",
    className: "column-updatedAddress1",
    columnName: "updatedAddress1",
    field: "updatedAddress1",
    width: 133,
    dataType: "boolean",
    field1: "updatedAddress1",
  },
  {
    value: 9,
    label: "Updated Date of Birth",
    className: "column-updatedBirthDate",
    columnName: "updatedBirthDate",
    field: "updatedBirthDate",
    width: 133,
    dataType: "boolean",
    field1: "updatedBirthDate",
  },
  {
    value: 10,
    label: "Updated Current Termination Date",
    className: "column-updatedTerminationDate",
    columnName: "updatedTerminationDate",
    field: "updatedTerminationDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedTerminationDate",
  },
  {
    value: 11,
    label: "Updated Employee Classification",
    className: "column-updatedEmployeeClassification",
    columnName: "updatedEmployeeClassification",
    field: "updatedEmployeeClassification",
    width: 233,
    dataType: "boolean",
    field1: "updatedEmployeeClassification",
  },
  {
    value: 12,
    label: "Updated PreTax Eligibility Date",
    className: "column-updatedPreTaxEligibilityDate",
    columnName: "updatedPreTaxEligibilityDate",
    field: "updatedPreTaxEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedPreTaxEligibilityDate",
  },
  {
    value: 13,
    label: "Updated Roth Eligibility Date",
    className: "column-updatedRothEligibilityDate",
    columnName: "updatedRothEligibilityDate",
    field: "updatedRothEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedRothEligibilityDate",
  },
  {
    value: 14,
    label: "Updated PreTax Catch Up Eligibility Date",
    className: "column-updatedPretaxCatchupEligibilityDate",
    columnName: "updatedPretaxCatchupEligibilityDate",
    field: "updatedPretaxCatchupEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedPretaxCatchupEligibilityDate",
  },
  {
    value: 15,
    label: "Updated Roth Catch Up Eligibility Date",
    className: "column-updatedRothCatchupEligibilityDate",
    columnName: "updatedRothCatchupEligibilityDate",
    field: "updatedRothCatchupEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedRothCatchupEligibilityDate",
  },
  {
    value: 16,
    label: "Updated AfterTax Eligibility Date",
    className: "column-updatedAftertaxEligibilityDate",
    columnName: "updatedAftertaxEligibilityDate",
    field: "updatedAftertaxEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedAftertaxEligibilityDate",
  },
  {
    value: 17,
    label: "Updated Match Eligibility Date",
    className: "column-updatedMatchEligibilityDate",
    columnName: "updatedMatchEligibilityDate",
    field: "updatedMatchEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedMatchEligibilityDate",
  },
  {
    value: 18,
    label: "Updated Safe Harbor Match Eligibility Date",
    className: "column-updatedSafeHarborMatchEligibilityDate",
    columnName: "updatedSafeHarborMatchEligibilityDate",
    field: "updatedSafeHarborMatchEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedSafeHarborMatchEligibilityDate",
  },
  {
    value: 19,
    label: "Updated Safe Harbor Non-Elective Eligibility Date",
    className: "column-updatedSafeHarborNonElectiveEligibilityDate",
    columnName: "updatedSafeHarborNonElectiveEligibilityDate",
    field: "updatedSafeHarborNonElectiveEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedSafeHarborNonElectiveEligibilityDate",
  },
  {
    value: 20,
    label: "Updated Profit Sharing Eligibility Date",
    className: "column-updatedProfitSharingEligibilityDate",
    columnName: "updatedProfitSharingEligibilityDate",
    field: "updatedProfitSharingEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedProfitSharingEligibilityDate",
  },
  {
    value: 21,
    label: "Updated Prevailing Wages Eligibility Date",
    className: "column-updatedPrevailingWagesEligibilityDate",
    columnName: "updatedPrevailingWagesEligibilityDate",
    field: "updatedPrevailingWagesEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedPrevailingWagesEligibilityDate",
  },
  {
    value: 22,
    label: "Updated QMAC Eligibility Date",
    className: "column-updatedQMACEligibilityDate",
    columnName: "updatedQMACEligibilityDate",
    field: "updatedQMACEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedQMACEligibilityDate",
  },
  {
    value: 23,
    label: "Updated QNEC Eligibility Date",
    className: "column-updatedQNECEligibilityDate",
    columnName: "updatedQNECEligibilityDate",
    field: "updatedQNECEligibilityDate",
    width: 233,
    dataType: "boolean",
    field1: "updatedQNECEligibilityDate",
  },
];

const ParticipantUpdateReport = (props) => {
  const formName = manageReportsFormNames.PARTICIPANT_UPDATE_DATA_REPORT;
  const fields = formFields[formName];
  const [companyList, setCompanyList] = useState("");
  const [sponOrgList, setSponOrgList] = useState("");
  const [planList, setPlanList] = useState([]);
  const [final, setFinal] = useState(columns);
  const [toggle, setToggle] = useState(false);
  const [filteredValues, setFilteredValues] = useState({
    from: 1,
    count: 20,
  });
  const [totalRecord, setTotalRecord] = useState(0);

  const today = new Date();
  const initialValues = {
    // companyName: "Select One",
    companyId: null,
    planName: "All",
    [fields.updatedDateTo]: new Date(today.setDate(today.getDate())),
    [fields.updatedDateFrom]: new Date(today.setDate(today.getDate() - 30)),
  };

  // const [dataChange, setDataChange] = useState([]);
  // const [displayColumns, setDisplayColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(
    Array.from({ length: columns.length }, (_, i) => i + 1)
  );

  const [isScroll, setIsScroll] = useState(false);
  const [g402Table, setG402Table] = useState([]);
  const [gridFilters, setGridFilters] = useState();
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [sorting, setSorting] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [trigger, setTrigger] = useState(true);

  const showManageColumns = () => {
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };
  const hideColumns = () => {
    setSelectedColumns(final.map((item) => item.value));
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "block") {
      x[0].style.display = "none";
    } else {
      x[0].style.display = "block";
    }
  };
  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });
  const applyColumns = () => {
    if (selectedColumns.length >= 1) {
      setFinal(
        columns.filter((column) =>
          selectedColumns.map((x) => x).includes(column.value)
        )
      );
      setIsScroll(true);
    } else {
      setFinal(emptycol);
      setIsScroll(false);
    }
    hideColumns();
  };

  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });
  const { response: sponsors } = useRequest({
    method: getSponsorOrganizationList,
    defaultResponse: [],
  });

  const apiCall = (data) => {
    setDataLoading(true);
    getParticipantUpdatesReportInfo(data)
      .then((response) => {
        setDataLoading(false);
        setG402Table(response.participantUpdateReportDatas);
        setTotalRecord(response.count);
        if (response.count > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);
      });
  };

  useDeepEffect(() => {
    if (!isEmpty(companyList) || !isEmpty(sponOrgList)) {
      setFilteredValues({
        ...filteredValues,
        innerFilters: gridFilters,
      });
      apiCall({ ...filteredValues, innerFilters: gridFilters });
    }
  }, [gridFilters]);

  const onSubmit = (values) => {
    setGridFilters(null);
    if (values.companyId !== null || values.sponsorOrganizationId !== null) {
      setCompanyList(values.companyName);
      setSponOrgList(values[fields.sponsorOrganizationName]);
      setPageCount(1);
      setIsScroll(true);
      var filters = {
        companyId: values.companyId ? values.companyId : 0,
        sponsorOrganizationId: values.sponsorOrganizationId
          ? values.sponsorOrganizationId
          : 0,
        planId: values.companyId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        [fields.masterPlanId]: values.sponsorOrganizationId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        [fields.nameOrSsn]: values[fields.nameOrSsn],
        [fields.updatedDateFrom]: values[fields.updatedDateFrom],
        [fields.updatedDateTo]: values[fields.updatedDateTo],
        from: 1,
        count: 20,
        innerFilters: null,
        selectedColumns: selectedColumns,
      };
      setFilteredValues(filters);
      apiCall(filters);
    } else {
      setIsScroll(false);
      setG402Table([]);
      setCompanyList("");
      setSponOrgList("");
    }
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          companyId: filteredValues.companyId,
          planId:
            planList.length === 1
              ? planList[0].planId
              : !filteredValues.planId
              ? 0
              : filteredValues.planId,
          nameOrSsn: filteredValues.nameOrSsn,
          updatedDateFrom: filteredValues.updatedDateFrom,
          updatedDateTo: filteredValues.updatedDateTo,
          masterPlanId: filteredValues.masterPlanId,
          from: fromCount,
          count: 20,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);
        setDataLoading(true);
        getParticipantUpdatesReportInfo(filters)
          .then((response) => {
            setDataLoading(false);
            if (response.participantUpdateReportDatas.length === 0) {
              setIsScroll(false);
            } else {
              setG402Table([
                ...g402Table,
                ...response.participantUpdateReportDatas,
              ]);
            }
          })
          .catch((error) => {
            setDataLoading(false);
          });
      }
    }
  };

  const exportReportFile = () => {
    var column = columns.filter(
      (column) => !final.map((item) => item.value).includes(column.value)
    );
    var data = column.map((item) => item.value);
    getDownloadParticipantUpdatesReport({
      ...filteredValues,
      selectedColumns: data,
    })
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `ParticipantUpdatesReport_${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };

  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    return <td>{value ? <div>{value}</div> : <div> -</div>}</td>;
  };
  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };

  const booleanFieldRender = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    let temp = "-";
    if (value === true) temp = "TRUE";
    else if (value === false) temp = "FALSE";
    return renderValue(temp);
  };

  const ssnGridCell = (props) => {
    var value = ssnMasking(props.dataItem.ssn);
    return renderValue(value);
  };

  return (
    <ManageReportLayout rptName="Participant Updates">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
            }}
            onSubmit={onSubmit}
            // enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };

              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      allOption,
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];
              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.companyId]:
                    value || value === 0
                      ? parseInt(companies[value].companyId)
                      : null,
                  [fields.companyName]:
                    value || value === 0
                      ? companies[value].companyName
                      : "Select One",
                });
                getPlansDropDown(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const OnSponsorChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.sponsorOrganizationId]:
                    value || value === 0 ? parseInt(sponsors[value].id) : null,
                  [fields.sponsorOrganizationName]:
                    value || value === 0 ? sponsors[value].name : "Select One",
                });

                getMasterPlanList(get(sponsors[value], "id", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };

              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                  setFieldValue(fields.planName, "All");
                }
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10 header-button-form"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div
                    className="d-flex align-item-center justify-content-between"
                    style={{ width: "fit-content" }}
                  >
                    <div className="d-flex mr-2">
                      <Field
                        size="sm"
                        isRequired
                        label={`Sponsoring organization ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.sponsorOrganizationName}
                        value={values[fields.sponsorOrganizationName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.companyName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.companyName]) ? (
                            <div style={{ width: "130px" }}>
                              {" "}
                              Select a sponsoring organization or company{" "}
                            </div>
                          ) : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Sponsor Organization"
                            // options={sponsoringOrganisationList}
                            options={
                              sponsors && [
                                //selectOne,
                                ...sponsors.map((sponsor, index) => ({
                                  label: sponsor.name,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => OnSponsorChange(value)}
                            selectedValue={
                              values[fields.sponsorOrganizationName]
                            }
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        size="sm"
                        isRequired
                        label={`Company Name ${
                          !values[fields.sponsorOrganizationName] ? "*" : ""
                        }`}
                        name={fields.companyName}
                        disabled={values[fields.sponsorOrganizationName]}
                        value={values[fields.companyName]}
                        placeholder="Select One"
                        direction="bottom"
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.sponsorOrganizationName])
                            ? " "
                            : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={
                              companies && [
                                //selectOne,
                                ...companies.map((company, index) => ({
                                  label: company.companyName,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => onCompanyChange(value)}
                            selectedValue={values[fields.companyName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <div className="d-flex ml-3">
                        <Field
                          size="sm"
                          isRequired
                          label={`plan Id ${
                            !values[fields.companyName] ? "*" : ""
                          }`}
                          name={fields.planName}
                          value={
                            values[fields.planName]
                              ? values[fields.planName]
                              : values[fields.companyName] && "All"
                          }
                          placeholder="Select"
                          direction="bottom"
                          validate={(value) =>
                            values[fields.sponsorOrganizationName] &&
                            ["", undefined, null, "Select One"].includes(value)
                              ? "Select a plan"
                              : null
                          }
                          popupContent={
                            <SearchableList
                              options={selectPlanOptions}
                              onSelect={(value) => onPlanChange(value)}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      {/* <div className="d-flex ml-3">
                        <div style={{ position: "relative", display: "flex" }}>
                          <Field
                            size="sm"
                            label="&nbsp;"
                            placeholder="Search SSN, Name"
                            label="Search"
                            isRequired
                            name={fields.nameOrSsn}
                            type="text"
                            autoComplete="off"
                            value={values[fields.nameOrSsn]}
                            onChange={handleChange}
                            component={FieldInput}
                          />
                          {values[fields.nameOrSsn] &&
                            values[fields.nameOrSsn].length != 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: "5px",
                                  top: "5px",
                                  height: "100%",
                                  marginTop: "30px",
                                  marginRight: "5px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  color="#000"
                                  size="sm"
                                  onClick={() => {
                                    setFieldValue(fields.nameOrSsn, "");
                                  }}
                                />
                              </div>
                            )}
                        </div>
                      </div> */}
                      <div className="d-flex ml-3 mr-3 ">
                        <Field
                          size="sm"
                          label="Updated date from"
                          isRequired
                          name={fields.updatedDateFrom}
                          value={usDateFormat(values[fields.updatedDateFrom])}
                          direction="bottom"
                          isDatePicker
                          onClear={() =>
                            setFieldValue(fields.updatedDateFrom, null)
                          }
                          validate={(value) =>
                            ["", undefined, null, "Select One"].includes(
                              value
                            ) && isEmpty(values[fields.updatedDateFrom])
                              ? "Required"
                              : null
                          }
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.updatedDateFrom, value)
                              }
                              value={usDateFormat(
                                values[fields.updatedDateFrom]
                              )}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-3">
                        <Field
                          size="sm"
                          label="Updated date to"
                          isRequired
                          name={fields.updatedDateTo}
                          value={usDateFormat(values[fields.updatedDateTo])}
                          direction="bottom"
                          isDatePicker
                          onClear={() =>
                            setFieldValue(fields.updatedDateTo, null)
                          }
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.updatedDateTo, value)
                              }
                              value={usDateFormat(values[fields.updatedDateTo])}
                            />
                          }
                          component={FieldDropSide}
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              ""
                            ) : value <= values[fields.updatedDateFrom] ? (
                              <div style={{ width: "150px" }}>
                                {" "}
                                Should be ahead of "Updated date from"
                              </div>
                            ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                            undefined;
                          }}
                        />
                      </div>
                      <div className="d-flex ml-3 ">
                        <Button
                          className=" mt-12 sort-button"
                          style={{ marginBottom: "12px", marginTop: "30px" }}
                          variant="secondary"
                          onClick={(e) => {
                            setValues({
                              ...clearFieldValues({
                                values,
                                fieldsToClear: [
                                  fields.planId,
                                  fields.planName,
                                  fields.companyId,
                                  fields.companyName,
                                  fields.sponsorOrganizationName,
                                  fields.sponsorOrganizationId,
                                  fields.updatedDateFrom,
                                  fields.updatedDateTo,
                                ],
                              }),
                            });
                            setFieldValue(
                              fields.updatedDateFrom,
                              initialValues.updatedDateFrom
                            );
                            setFieldValue(
                              fields.updatedDateTo,
                              initialValues.updatedDateTo
                            );
                            setFieldValue(fields.search, "");
                            setFieldValue(fields.planName, null);
                            setFieldValue(fields.planId, null);
                            setPlanList([]);
                            setErrors({});
                            setTotalRecord(0);
                            setG402Table([]);
                            setCompanyList("");
                            setSponOrgList("");
                          }}
                        >
                          Reset
                        </Button>
                      </div>
                      <div className="d-flex ml-3 ">
                        <Button
                          className="mt-12 sort-button"
                          style={{
                            lineHeight: "19px",
                            marginRight: "10%",
                            marginBottom: "12px",
                            marginTop: "30px",
                          }}
                          variant="secondary"
                          type="submit"
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{ maxWidth: "100%" }}
                    className="d-flex justify-content-between align-center divSpace header-button min-width-200 mr-0"
                  >
                    <div className="d-flex flex-col">
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#828282",
                          paddingTop: "6px",
                        }}
                      >
                        {companyList
                          ? `Showing result for ${companyList} company`
                          : null}
                      </div>
                      <div className="ft-12 grey-text font-weight-500">
                        {totalRecord} Records found
                      </div>
                    </div>
                    <div className="d-flex pad-top-10">
                      <div
                        style={{
                          diplay: "flex",
                          flexDirection: "column",
                          marginLeft: "100px",
                        }}
                      >
                        <div>
                          <Button
                            variant="secondary"
                            className="column-header"
                            onClick={showManageColumns}
                          >
                            <span className="marg-right-6">
                              <i class="fal fa-columns"></i>
                            </span>
                            Column
                          </Button>
                        </div>
                        <div
                          className="manage-column-dropdown"
                          style={{ display: "none" }}
                        >
                          <div className="manage-columns ">
                            <p className="manage-columns-button">
                              {" "}
                              Manage columns
                            </p>
                            <p
                              className="apply-button"
                              onClick={() => {
                                hideColumns();
                                setTrigger(!trigger);
                              }}
                            >
                              Close
                            </p>
                          </div>
                          <div>
                            <MultiSelectDropdown
                              hideSelectedOptions="FALSE"
                              width="269px"
                              height="200px"
                              maxHeight="300px"
                              position="absolute"
                              background="white"
                              zIndex="2"
                              options={columns}
                              onSelect={(value) => {
                                setSelectedColumns(value);
                              }}
                              name={"Columns"}
                              value={selectedColumns}
                              trigger={trigger}
                              // disabled={}
                              // isTypeAhead={isEdit}
                            />
                          </div>
                          <div
                            style={{ marginTop: "220px", paddingLeft: "100px" }}
                          >
                            <Button onClick={applyColumns}>Apply</Button>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{ width: "177.467px" }}
                        className="ft-12 grey-text font-weight-500"
                      >
                        <Button
                          className="export-button"
                          title="Export Excel"
                          variant="secondary"
                          style={{ border: "none" }}
                          onClick={() =>
                            !isEmpty(g402Table) && exportReportFile()
                          }
                        >
                          <Image src={ExcelImage} width="20px" />
                          Export
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <div className="table-width grid-overflow" style={{ minWidth: "0px" }}>
          <ExcelExport data={g402Table}>
            <LoaderWrapper isLoading={dataLoading}>
              <Tooltip
                openDelay={100}
                position="bottom"
                anchorElement="element"
              >
                <Grid
                  data={g402Table}
                  style={{ height: "400px" }}
                  total={g402Table?.length}
                  onScroll={scrollHandler}
                  resizable={true}
                  fixedScroll
                >
                  {final.map((column, idx) => (
                    <GridColumn
                      key={idx}
                      width={column.width}
                      field={column.field}
                      title={column.label}
                      filter={column.dataType}
                      cell={
                        (column.dataType === "amount" &&
                          KendoGridDecimalCell) ||
                        (column.dataType === "boolean" && booleanFieldRender) ||
                        (column.dataType === "date" && dateForm) ||
                        renderValue
                      }
                      headerCell={ProductNameHeader}
                      columnMenu={(props) =>
                        !isEmpty(g402Table) ||
                        (gridFilters &&
                          (gridFilters[column.field1] ||
                            (column.field2 && gridFilters[column.field2]))) ? (
                          <GridInnerFilters
                            {...props}
                            fields={fields}
                            sorting={sorting}
                            setSorting={setSorting}
                            gridFilters={gridFilters}
                            setGridFilters={setGridFilters}
                            field1={column.field1}
                            field2={column.field2 ? column.field2 : null}
                            columns={selectedColumns}
                          />
                        ) : null
                      }
                    />
                  ))}
                </Grid>
              </Tooltip>
            </LoaderWrapper>
          </ExcelExport>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default ParticipantUpdateReport;
